import React from 'react';
import Button from '../Button';
import ExitIcon from './ExitIcon';
import IconButton from './IconButton';

export default function Modal({
    title,
    subtitle,
    children,
    isOpen,
    onClose,
    onAction,
    loading,
    actionText,
    size,
}: {
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
    isOpen: boolean;
    onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onAction?: () => void;
    loading?: boolean;
    actionText?: string;
    /**
     * Fixed dimensions instead of sizing to content. Use where the body
     * changes as the user interacts - without this the dialog resizes under
     * the cursor on every selection. Omitted, the modal behaves as before.
     */
    size?: 'md' | 'lg';
}) {
    if (!isOpen) {
        return <></>;
    }

    const sizeClass = (() => {
        if (size === 'lg') return 'w-11/12 max-w-4xl h-5/6';
        if (size === 'md') return 'w-11/12 max-w-2xl h-3/4';
        return '';
    })();

    return (
        <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex">
            <div
                className={`relative bg-surface border border-border shadow-lg m-auto flex-col flex rounded-xl ${sizeClass}`}
            >
                <div className={size ? 'flex flex-col min-h-0 flex-1' : undefined}>
                    <div className="text-lg font-semibold text-foreground px-6 py-4 border-b border-border">
                        {title}
                    </div>
                    {subtitle && (
                        <div className="text-sm text-foreground-secondary pt-6 pl-6 pr-6 mb-2">
                            <div>{subtitle}</div>
                        </div>
                    )}
                    <div className={size ? 'p-6 flex-1 min-h-0 overflow-y-auto' : 'p-6'}>
                        {children}
                    </div>
                    {onAction && (
                        <div>
                            <div className="border-t border-border" />
                            <div className="flex flex-row-reverse">
                                <div className="m-5">
                                    <Button disabled={loading} onClick={onAction}>
                                        {actionText || 'Submit'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <span className="absolute top-0 right-0 p-4">
                    <IconButton onClick={onClose}>
                        <ExitIcon />
                    </IconButton>
                </span>
            </div>
        </div>
    );
}
